<template>
    <header id="header" v-bind:class="{ 'withShadow': !canShowSdkMenu()}">
        <div class="deviceLangWrapper">
            <div class="desktopMenu">
                <ul class="top-menu" v-if="canShowSdkMenu()">
                    <li>
                        <a @click="setAndroidDevice" :class="{'active': isAndroidDeviceActive()}">Android</a>
                    </li>
                    <li>
                        <a @click="setIosDevice" :class="{'active': isIosDeviceActive()}">iOS</a>
                    </li>
                </ul>
                <div class="select-wrapper" v-if="canShowSdkMenu()">
                    <el-select v-model="version" size="mini" :default-first-option="true">
                        <el-option v-for="element in apiVersions"
                                   :value="element.version"
                                   :key="element.version"
                                   :label="getApiVersionLabel(element)">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="lang-wrapper" v-if="canShowSdkMenu() || isHomePage()">
                <ul>
                    <li v-for="element in getLangList()"
                        :class="{'active': isLangActive(element.value)}"
                        :key="element.value"
                        @click="setSdkLanguage(element.value)">
                        {{element.value}}
                    </li>
                </ul>
            </div>
            <div class="theme-wrapper">
                <div class="toggle-box">
                    <input type="checkbox" id="toggle-box-checkbox" v-model="darkThemeMode" />
                    <label for="toggle-box-checkbox" class="toggle-box-label-left"></label>
                    <label for="toggle-box-checkbox" class="toggle-box-label"></label>
                </div>
            </div>
            <div id="mobileNav" ref="mobileNav" @click="toggleMobileMenu()">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="top container">
            <el-row>
                <el-col>
                    <div class="topMenuWrapper">
                        <div class="logoTitleWrapper">
                            <div class="autopay-logo-wrapper">
                                <a class="autopay-logo" href="https://autopay.pl"></a>
                            </div>
                            <h1 class="pageTitle">
                                <span v-if="isHomePage()">{{ $t('home.heading')}}</span>
                                <span v-if="!isHomePage()">Autopay SDK</span>
                            </h1>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <div class="mobileMenuWrapper">
                        <ul class="top-menu" v-if="canShowSdkMenu()">
                            <li>
                                <a @click="setAndroidDevice" :class="{'active': isAndroidDeviceActive()}">Android</a>
                            </li>
                            <li>
                                <a @click="setIosDevice" :class="{'active': isIosDeviceActive()}">iOS</a>
                            </li>
                        </ul>
                        <div class="select-wrapper" v-if="canShowSdkMenu()">
                            <el-select v-model="version" size="mini" :default-first-option="true">
                                <el-option v-for="element in apiVersions"
                                           :value="element.version"
                                           :key="element.version"
                                           :label="getApiVersionLabel(element)">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div v-if="canShowSdkMenu()">
            <sdk-menu />
        </div>
        <div id="mobileSidebar" ref="mobileSidebar">
            <ul>
                <li><router-link @click.native="goToProductPage()" :to="{ path: ROUTING.autopaySdk.product }">{{ $t('menu.about') }}</router-link></li>
                <li><router-link @click.native="docsSectionClick()" :to="{ path: ROUTING.autopaySdk.docs.main }">{{ $t('menu.documentation') }}</router-link></li>
                <li><router-link @click.native="downloadSectionClick()" :to="{ path: ROUTING.autopaySdk.files.main }">{{ $t('menu.download') }}</router-link></li>
                <li><router-link @click.native="faqSectionClick()" :to="{ path: ROUTING.autopaySdk.faq.main }">{{ $t('menu.faq') }}</router-link></li>
                <li><router-link @click.native="setChangelogSectionActive()" :to="{ path: ROUTING.autopaySdk.changelog.main }">{{ $t('menu.changelog') }}</router-link></li>
            </ul>
        </div>
        <div id="mobileSidebarMask" ref="mobileSidebarMask" @click="closeMobileMenu()"></div>
    </header>
</template>

<script>
import { ROUTING } from '../../const/routing.const'
import { mapActions, mapMutations, mapState } from 'vuex'
import SdkMenu from '../Sdk/Menu'

export default {
  name: 'LayoutHeader',
  components: { SdkMenu },
  data () {
    return {
      ROUTING: ROUTING
    }
  },
  computed: {
    ...mapState({
      apiVersions: state => state.sdk.apiVersions,
      current: state => state.sdk.currentVersion,
      isLoading: state => state.sdk.isLoading,
      lang: state => state.sdk.lang,
      version: state => state.sdk.version,
      device: state => state.sdk.device
    }),
    darkThemeMode: {
      get () {
        return this.$store.state.app.darkThemeMode
      },
      set (value) {
        this.setDarkThemeMode(value)
      }
    },
    version: {
      get () {
        return this.$store.state.sdk.version
      },
      set (value) {
        this.changeSdkVersion(value)
      }
    }
  },
  methods: {
    ...mapActions([
      'getSdkApiVersionsList',
      'changeSdkVersion'
    ]),
    ...mapMutations([
      'setSdkLanguage',
      'setDarkThemeMode',
      'setSdkCurrentDevice',
      'setDownloadSectionActive',
      'setDownloadSectionInactive',
      'setDocsSectionActive',
      'setDocsSectionInactive',
      'setFaqSectionActive',
      'setChangelogSectionActive',
      'setChangelogSectionInactive'
    ]),
    getApiVersionLabel (item) {
      if (item.description && item.description.length) {
        return `${item.version} ${item.description}`
      }
      return item.version
    },
    isLangActive (lang) {
      return lang === this.lang
    },
    getLangList () {
      let result = []
      if (this.current && this.current.lang) {
        this.current.lang.map(item => {
          result.push({
            value: item.lang,
            text: item.text
          })
        })
      }
      return result
    },
    canShowSdkMenu () {
      const sdkRoutes = [
        ROUTING.autopaySdk.product,
        ROUTING.autopaySdk.docs.main,
        ROUTING.autopaySdk.files.main,
        ROUTING.autopaySdk.faq.main,
        ROUTING.autopaySdk.changelog.main
      ]
      return sdkRoutes.find(route => this.$route.path.startsWith(route))
    },
    isHomePage () {
      return this.$route.path === ROUTING.main
    },
    setAndroidDevice () {
      this.setSdkCurrentDevice('android')
    },
    setIosDevice () {
      this.setSdkCurrentDevice('ios')
    },
    isAndroidDeviceActive () {
      return this.device === 'android'
    },
    isIosDeviceActive () {
      return this.device === 'ios'
    },
    toggleMobileMenu () {
      this.$refs.mobileNav.classList.toggle('open')
      this.$refs.mobileSidebar.classList.toggle('open')
      this.$refs.mobileSidebarMask.classList.toggle('open')
    },
    closeMobileMenu () {
      this.$refs.mobileNav.classList.remove('open')
      this.$refs.mobileSidebar.classList.remove('open')
      this.$refs.mobileSidebarMask.classList.remove('open')
    },
    goToProductPage () {
      this.closeMobileMenu()
      this.setDownloadSectionInactive()
      this.setDocsSectionInactive()
      this.setChangelogSectionInactive()
    },
    docsSectionClick () {
      this.closeMobileMenu()
      this.setDocsSectionActive()
    },
    downloadSectionClick () {
      this.closeMobileMenu()
      this.setDownloadSectionActive()
    },
    faqSectionClick () {
      this.closeMobileMenu()
      this.setFaqSectionActive()
    }
  },
  created () {
    this.getSdkApiVersionsList()
  }
}
</script>
